import script from "./webRTC.vue?vue&type=script&setup=true&lang=js"
export * from "./webRTC.vue?vue&type=script&setup=true&lang=js"

import "./webRTC.vue?vue&type=style&index=0&id=69250314&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69250314"]])

export default __exports__